module.exports = __webpack_public_path__ + "static/media/logo_white.8472f68a.png";